"use client";

import S from "./index.module.scss";
import CustomIcon from "@/components/ui/custom-icon";
import { useMedia } from "@/hooks/system/useMedia";
import Menu from "./components/menu";

const Header = () => {
  const { isDesktop, isClient } = useMedia();
  return (
    <div className={S.borderWrapper}>
      <header className={S.wrapper}>
        <Menu />
        {isDesktop && isClient && (
          <div className={S.brandsWrapper}>
            <CustomIcon fileName="icon-ampm" />
            <CustomIcon fileName="icon-damixa" />
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;
